/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Security_Add_Passkey_DescriptionInputs */



/**
* | output |
* | --- |
* | "Give this passkey a name you will recognise later, such as the device it lives on." |
*
* @param {Partner_Security_Add_Passkey_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_security_add_passkey_description = /** @type {((inputs?: Partner_Security_Add_Passkey_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Security_Add_Passkey_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie diesem Passkey einen Namen, den Sie später wiedererkennen – zum Beispiel das Gerät, auf dem er liegt.")
	return /** @type {LocalizedString} */ ("Give this passkey a name you will recognise later, such as the device it lives on.")
});